module.exports = __webpack_public_path__ + "static/media/person-avatar.7544d13b.svg";